import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'

import {req} from '~/utils'

import root from './utils'

type MomentProps = {
  moment: {
    sessionId: string
    query: string
    characterId: number
    userId: number
    eventId: number
    status: string
    momentInfo: {
      title: string
      content: string
      hint: string
      url: string
    }
  }[]
  total: number
  unlockedCnt: number
}

const initialState = {
  moment: [],
  total: 0,
  unlockedCnt: 0,
} as MomentProps

// const root = 'http://mock.ixiaochuan.cn/project/412/interface/api/23263'
export const getUserEventMoments = createAsyncThunk<any, any>(
  'getUserEventMoments',
  async (arg, store) => {
    return req(
      '/xai_get_user_moment',
      // @ts-ignore
      {...store.getState().deviceInfo, ...arg},
      store,
      false,
      root
    )
  }
)

export const momentSlice = createSlice({
  name: 'moment',
  initialState,
  reducers: {
    clearMomentInfo(state) {
      return {
        ...state,
        moment: [],
        total: 0,
        unlockedCnt: 0,
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserEventMoments.fulfilled, (state, action) => {
      return {
        ...state,
        ...action.payload,
      }
    })
  },
})

export default momentSlice.reducer
